


















import BasePageTemplate from '@/views/templates/tenugui/BasePageTemplate.vue'
import MessageArea from '@/views/molecules/MessageArea.vue'

export default
  components: {
    BasePageTemplate
    MessageArea
  }

  data: () ->
    message: [
      '祖父が木綿業の創業者という環境で育った代表 宮本と、'
      '日本のモノづくりの新しい可能性を探求し続ける'
      'クリエイター 森野が、日本の風土にマッチし理にかなった'
      '機能性をもつ「てぬぐい」をより実用性と現代的な'
      'プロダクトに進化していく事をモットーに'
      'CHAORAS®をスタートさせました。'
    ]

  methods: {
    scrollFire: () ->
      @$emit('scrollFire')
  }
